import { actionNames } from './actions'

const mainReducer = (state = [], action) => {
  switch (action.type) {
    case actionNames.FETCH_TIMEZONES_SUCCESS: {
      return action.timezones
    }
    default:
      return state
  }
}

export default mainReducer
